import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import { List } from 'material-ui/List';
import { ListItem } from 'material-ui/List';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import { AccentColor } from 'helpers/AccentColorHelper';

import { getDocuments } from 'actions/downloadActions';
import DocumentDownloadListItems from './DocumentDownloadListItems';
import { localize } from 'react-localize-redux';

const DownloadDocuments = withMobileDialog()(
  connect(
    store => {
      return {
        documents: store.downloads.documents,
        numberOfDocuments: store.downloads.numberOfDocuments,
      };
    },
    { getDocuments }
  )(
    class DownloadDocuments extends Component {
      constructor(props, context) {
        super(props, context);
        this.state = {
          componentHeight: '279px',
          isExpanded: false,
        };
      }

      componentDidMount = () => {
        this.props.getDocuments();
      };

      render() {
        return (
          <Dialog
            fullScreen={this.props.fullScreen}
            open={this.props.isOpen}
            onClose={this.props.toggleDialog}
            aria-labelledby="view-documents"
            classes={{
              paper: 'form-dialog',
            }}
          >
            <DialogTitle id="view-documents">
              <h3 style={{ margin: '10px 0 5px', textAlign: 'center' }}>
                {this.props.translate('documents')}
                <b style={{ fontFamily: 'Circular-Black', color: AccentColor() }}>.</b>
              </h3>
              <p style={{ fontSize: '12px', marginBottom: 0, textAlign: 'center' }}>
                {this.props.translate('documents.disclaimer')}
              </p>
            </DialogTitle>
            <DialogContent>
              <div style={{ borderTop: `5px solid ${AccentColor()}`, marginTop: '5px' }}>
                {this.renderTenantDocuments()}
              </div>
            </DialogContent>
            <DialogActions style={{ display: 'block' }}>{this.renderDialogActions()}</DialogActions>
          </Dialog>
        );
      }

      renderTenantDocuments = () => {
        return (
          <div className="row">
            {this.renderDocumentsList()}
            {this.renderNoDocumentsList()}
          </div>
        );
      };

      renderDocumentsList = () => {
        if (this.props.numberOfDocuments === 0) return;

        const documents_list = Object.keys(this.props.documents).map(key => (
          <DocumentDownloadListItems
            key={key}
            listItemType={key}
            documents={this.props.documents[key]}
          />
        ));

        return <List style={{ padding: 0 }}>{documents_list}</List>;
      };

      renderNoDocumentsList = () => {
        if (this.props.numberOfDocuments > 0) return;

        return (
          <List style={{ padding: 0 }}>
            <ListItem
              primaryText={
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                  <span style={{ fontSize: '15px' }}>
                    {this.props.translate('documents.messages.noDocuments')}
                  </span>
                </div>
              }
            />
          </List>
        );
      };

      renderDialogActions = () => (
        <Fragment>
          <FlatButton
            onClick={this.props.toggleDialog}
            id="close-button"
            style={{ color: AccentColor(), textTransform: 'uppercase' }}
          >
            {this.props.translate('close')}
          </FlatButton>
        </Fragment>
      );
    }
  )
);

export default localize()(DownloadDocuments);
